import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { OrganizationMember } from '@reach/shared-types/workos-auth';
import { MoreHorizontal } from 'lucide-react';

interface MemberActionsProps {
  member: OrganizationMember;
  isCurrentUser: boolean;
  onDeactivate: () => void;
  onReactivate: () => void;
}

export function MemberActions({
  member,
  isCurrentUser,
  onDeactivate,
  onReactivate,
}: MemberActionsProps) {
  if (isCurrentUser) return null;

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className="p-1 rounded-md hover:bg-gray-100 text-gray-400 hover:text-gray-600">
          <MoreHorizontal className="h-4 w-4" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={4}
          className="z-50 min-w-[176px] bg-white rounded-md shadow-lg border border-gray-200 py-1">
          {member.status === 'active' ? (
            <DropdownMenu.Item
              onSelect={onDeactivate}
              className="px-4 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer outline-none">
              Deactivate
            </DropdownMenu.Item>
          ) : (
            <DropdownMenu.Item
              onSelect={onReactivate}
              className="px-4 py-2 text-sm text-green-600 hover:bg-green-50 cursor-pointer outline-none">
              Reactivate
            </DropdownMenu.Item>
          )}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
